import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="relative bg-black py-10 lg:py-20 px-4 lg:px-8">
      {/* Glitch Decoration at Top */}
      <div className="absolute top-0 left-0 right-0 h-1 flex">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="flex-1"
            style={{
              background: ['#ff006e', '#00ff41', '#00d9ff'][i % 3],
              height: Math.random() > 0.5 ? '1px' : '3px',
              boxShadow: `0 0 10px ${['#ff006e', '#00ff41', '#00d9ff'][i % 3]}`,
            }}
          />
        ))}
      </div>

      <div className="container mx-auto max-w-7xl">
        <div
          className="bg-black rounded-2xl lg:rounded-[32px] border border-white/10 p-6 sm:p-10 lg:p-16 mx-0 lg:mx-10"
          style={{ boxShadow: '0 0 60px rgba(0, 255, 65, 0.1)' }}
        >
          {/* Top Section */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 pb-10 lg:pb-16 border-b border-white/10">
            {/* Left - Newsletter */}
            <div className="lg:col-span-5">
              <h3 className="font-display text-3xl lg:text-6xl text-white mb-3 lg:mb-6 tracking-wide">
                STAY<br />UNDERGROUND
              </h3>
              <p className="text-gray-400 text-sm lg:text-lg leading-relaxed mb-6 lg:mb-8">
                最新のアーティスト情報、ライブイベント、<br className="hidden sm:block" />
                NFCタグの配布場所をお届けします。
              </p>

              <div className="mb-4 lg:mb-6">
                <input
                  type="email"
                  placeholder="your@email.com"
                  className="w-full lg:w-4/5 bg-transparent border-b-2 border-neon-green py-3 lg:py-4 text-white text-sm lg:text-lg placeholder-gray-600 focus:outline-none focus:border-neon-pink transition-colors duration-300"
                  style={{ boxShadow: '0 2px 0 rgba(0, 255, 65, 0.3)' }}
                />
              </div>

              <button className="px-8 lg:px-10 py-3 lg:py-4 bg-white rounded-full text-black font-bold text-sm lg:text-lg tracking-wider hover:-translate-y-1 hover:shadow-[0_10px_40px_rgba(255,255,255,0.4)] transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer">
                SUBSCRIBE
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>

            {/* Middle - Navigation */}
            <div className="lg:col-span-3 lg:col-start-7">
              <h4 className="text-gray-500 text-xs tracking-[0.3em] mb-4 lg:mb-6 uppercase">Explore</h4>
              <ul className="flex flex-wrap gap-4 lg:block lg:space-y-5">
                {['Makers', 'Seekers', 'Experience', 'NFC Redirect'].map((link, index) => (
                  <li key={index}>
                    <a
                      href={`#${link.toLowerCase().replace(' ', '-')}`}
                      className="text-white text-sm lg:text-lg font-light hover:text-neon-green transition-colors duration-300 inline-block relative group"
                    >
                      {link}
                      <span
                        className="absolute bottom-0 left-0 w-0 h-px bg-neon-green group-hover:w-full transition-all duration-300"
                        style={{ boxShadow: '0 0 10px #00ff41' }}
                      />
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right - Contact */}
            <div className="lg:col-span-3">
              <h4 className="text-gray-500 text-xs tracking-[0.3em] mb-4 lg:mb-6 uppercase">Contact</h4>
              <div className="space-y-2 lg:space-y-4 mb-6 lg:mb-8">
                <p className="text-white text-sm lg:text-lg">hello@crash-music.com</p>
                <p className="text-white text-sm lg:text-lg">+81 3-1234-5678</p>
              </div>

              <h4 className="text-gray-500 text-xs tracking-[0.3em] mb-3 lg:mb-4 uppercase">Location</h4>
              <p className="text-white text-sm lg:text-lg leading-relaxed">
                東京都渋谷区<br />
                道玄坂 2-10-12
              </p>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="pt-6 lg:pt-8 flex flex-col sm:flex-row items-center gap-4 sm:justify-between">
            {/* Left - Social Links */}
            <div className="flex gap-4 lg:gap-6">
              {['twitter', 'instagram', 'youtube'].map((social, index) => (
                <a
                  key={index}
                  href="#"
                  className="text-white text-xs lg:text-base hover:text-neon-pink transition-colors duration-300 relative group"
                >
                  {social.charAt(0).toUpperCase() + social.slice(1)}
                  <span className="absolute bottom-0 left-0 w-full h-px bg-neon-pink opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </a>
              ))}
            </div>

            {/* Center - Copyright */}
            <div className="text-gray-500 text-[10px] lg:text-sm text-center order-last sm:order-none">
              © 2025 DigDim. All rights reserved. |{' '}
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hover:text-neon-green transition-colors duration-300"
              >
                Powered by Readdy
              </a>
            </div>

            {/* Right - Policy Links */}
            <div className="flex gap-4 lg:gap-6">
              <Link
                to="/legal-notice"
                className="text-white text-xs lg:text-base hover:text-neon-blue transition-colors duration-300 relative group whitespace-nowrap"
              >
                特定商取引法
                <span className="absolute bottom-0 left-0 w-full h-px bg-neon-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </Link>
              <Link
                to="/terms"
                className="text-white text-xs lg:text-base hover:text-neon-blue transition-colors duration-300 relative group whitespace-nowrap"
              >
                利用規約
                <span className="absolute bottom-0 left-0 w-full h-px bg-neon-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </Link>
              <Link
                to="/privacy"
                className="text-white text-xs lg:text-base hover:text-neon-blue transition-colors duration-300 relative group whitespace-nowrap"
              >
                プライバシー
                <span className="absolute bottom-0 left-0 w-full h-px bg-neon-blue opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}